{
  "id": "default-contrast",
  "name": "Default Contrast",
  "description": "Default theme with greyish dark mode for better contrast",
  "colors": {
    "light": {
      "primary": "#1976d2",
      "secondary": "#ddeaf8",
      "positive": "#21ba45",
      "negative": "#f44336",
      "warning": "#ffcc00",
      "important": "#ff8f00",
      "light": "#fafafa",
      "dark": "#09090b",
      "surface": "#eeeeee",
      "darksurface": "#18181b",
      "white": "#ffffff"
    },
    "dark": {
      "primary": "#4b6d9e",
      "secondary": "#4a5058",
      "positive": "#6bc98a",
      "negative": "#e57373",
      "warning": "#e6c347",
      "important": "#d9a050",
      "light": "#e8e8e8",
      "dark": "#1a1a1c",
      "surface": "#d4d4d4",
      "darksurface": "#28282c",
      "white": "#f5f5f5"
    }
  }
}
